// Voltar para onde a pessoa estava depois do login: link de card/board
// compartilhado no WhatsApp, ou sessão que expirou no meio do trabalho —
// antes caía sempre no Início e o link se perdia.

/** /login?next=<caminho atual>, ou só /login quando não há para onde voltar. */
export function loginPathFor(path: string): string {
  if (!path || path === '/' || path.startsWith('/login')) return '/login';
  return `/login?next=${encodeURIComponent(path)}`;
}

/** Destino seguro do ?next= — só caminhos internos (nada de //outro-site). */
export function nextFromSearch(search: string): string | null {
  const next = new URLSearchParams(search).get('next');
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/login')) return null;
  return next;
}
